import { enUS } from 'date-fns/locale'

export const i18nLocEn = {
  __icon: '🇺🇸',
  __title: 'English',
  __dateFnsLocale: enUS,
  translation: {},
}
